import { Component, HostListener, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Principal } from '../../shared/auth/principal.service';
import { ConsumableAdstxtRecord } from '../../shared/domain/consumable-adstxt-record.model';
import { LoginService } from '../../shared/auth/login/login.service';
import { MomentDateUtils } from '../../shared/utils/moment-date-utils';
// import {Publisher} from '../../shared/domain/publisher.model';

import * as moment from 'moment';
import { PublisherStatsService } from '../shared/services/publishers-stats.service';

@Component({
  selector: 'cm-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  // public publisher: Publisher = new Publisher();
  showAdsTxtAlert = false;
  screenWidth: number;
  mobileTopBar = document.getElementsByClassName('mobile-top-bar');
  scrollOffset: number;

  constructor(public principal: Principal,
              private httpClient: HttpClient,
              private service: PublisherStatsService,
              private loginService: LoginService) {
    this.screenWidth = window.innerWidth;
  }


  ngOnInit(): void {
    this.checkForUpdatedAdsTxts();
  }

  checkForUpdatedAdsTxts() {
    this.service.publisherAdsTxtRecords('SITE')
      .subscribe((next: ConsumableAdstxtRecord[]) => {

        let findUpdatedAdsTxtInLastTwoWeeks = false;
        for (let i = 0; i < next.length; i++) {
          const today = moment().format('YYYY-MM-DD');
          const updatedOnFormated = moment(next[i].updatedOn).format('YYYY-MM-DD');

          if (MomentDateUtils.getDurationInDays(updatedOnFormated, today) < 14) {
            findUpdatedAdsTxtInLastTwoWeeks = true;
            break;
          }
        }
        this.showAdsTxtAlert = findUpdatedAdsTxtInLastTwoWeeks;
      });
  }

  isIntroCompleted() {
    return !this.principal.publisher || (!this.principal.publisher.selfServed || this.principal.publisher.ssIntroCompleted);
  }

  isTipaltiNotPaid() {
    return this.principal.publisher && this.principal.publisher.tipaltiId && !this.principal.publisher.tipaltiPayable;
  }

  public logout() {
    this.loginService.logout(true);
  }

  inventoryRouterLink() {
    let link = '/inventory';
    const p = this.principal.publisher;
    if (p.adTagEnabled && !p.bidderEnabled) {
      link = '/inventory/ad-tags';
    }
    if (!p.adTagEnabled && p.bidderEnabled) {
      link = '/inventory/bidder';
    }
    return link;
  }
  productsRouterLink() {
    let link = '/products';
    const p = this.principal.publisher;
    if (p.adTagEnabled && !p.bidderEnabled) {
      link = '/products/ad-tags';
    }
    if (!p.adTagEnabled && p.bidderEnabled) {
      link = '/products/bidder';
    }
    return link;
  }

  @HostListener('window:resize')
  resizeScreen() {
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    // console.log($event);
    if ($event.path && $event.path.length) {
      this.scrollOffset = $event.path[1].scrollY;
    } else {
      this.scrollOffset = 0;
    }
  }
}

